import { render, staticRenderFns } from "./checkout-total-widget.vue?vue&type=template&id=508beacf&"
import script from "./checkout-total-widget.vue?vue&type=script&lang=js&"
export * from "./checkout-total-widget.vue?vue&type=script&lang=js&"
import style0 from "./checkout-total-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508beacf')) {
      api.createRecord('508beacf', component.options)
    } else {
      api.reload('508beacf', component.options)
    }
    module.hot.accept("./checkout-total-widget.vue?vue&type=template&id=508beacf&", function () {
      api.rerender('508beacf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-total-widget/checkout-total-widget.vue"
export default component.exports